export default __webpack_public_path__ + "static/dude1-ddfadd6291be247e02a9b190e33d5c1f.png";